import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useFormikContext } from 'formik'

import { setFormValidity, FormDefaultState, setFormValidating } from '../store/sale.reducer'

import { selectShouldValidate } from '~/sale/store/sale.selectors'

interface UseValidateForm {
  lineId: string
  form: keyof FormDefaultState
  isValidForm: boolean
  refreshValue?: boolean
}

export default function useValidateForm({
  lineId,
  form,
  isValidForm,
  refreshValue,
}: UseValidateForm) {
  const dispatch = useDispatch()
  const { validateForm, setTouched, isValid } = useFormikContext()
  const shouldValidate = useSelector(selectShouldValidate)
  useEffect(() => {
    async function validate() {
      dispatch(setFormValidating({ lineId, form, isValidating: true }))
      const errors = await validateForm()
      setTouched(errors)
      dispatch(setFormValidating({ lineId, form, isValidating: false }))
    }
    if (shouldValidate) {
      validate()
    }
  }, [shouldValidate])

  useEffect(() => {
    dispatch(setFormValidity({ lineId, form, isValid: isValidForm }))
    return () => {
      dispatch(setFormValidity({ lineId, form, isValid: true }))
    }
  }, [isValid, refreshValue])
}
